import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const PatioDoorType = ({ value, onChange, id = 'PatioDoorType', label = 'Patio Door Type', disabled = false }) => {
    const defaultValue = value?.value || '';
    const [selectedDoorType, setSelectedDoorType] = useState(defaultValue);

    // Patio door type options with label/value pattern
    const doorTypes = [
        { id: 1, value: 'Sliding', label: 'Sliding Door' },
        { id: 2, value: 'TripleSliding', label: 'Triple Sliding Door' },
        { id: 3, value: 'QuadSliding', label: 'Quad Sliding Door' },
    ];

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedDoorType(value?.value || '');
    }, [value?.value]);

    // Trigger initial onChange once when component mounts
    useEffect(() => {
        if (doorTypes.length > 0 && !selectedDoorType) {
            const defaultOption = doorTypes[0];
            const newValue = defaultOption?.value || '';
            const newLabel = defaultOption?.label || '';
            setSelectedDoorType(newValue);
            onChange({ value: newValue, label: newLabel });
        }
    }, []);

    const handleDoorTypeChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedDoorType(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedDoorType}
                onChange={handleDoorTypeChange}
            >
                {doorTypes.map(option => (
                    <option key={option.id} value={option.value}>
                        {selectedDoorType === option.value ? `${option.label} ✔` : option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default PatioDoorType;
